@if (detailsData(); as detailsElementData) {
	<div>
		<div class="top-detail">
			<app-pasfoto [pasfoto]="detailsElementData.pasfoto" size="size-3"></app-pasfoto>
			<div class="top-detail__text">
				<span class="name">{{ detailsElementData.title }}</span>
				<br />
				@for (subTitle of detailsElementData.subTitle; track subTitle; let last = $last) {
					<span>
						<span class="detail">{{ subTitle }}</span>
						@if (!last) {
							<span class="bullit"> • </span>
						}
					</span>
				}
			</div>
			<div class="top-detail__buttons" data-princexml-ignore data-html2canvas-ignore>
				@if (showNext()) {
					<div class="button" title="Vorige {{ type() }}" (click)="changeElement.emit(false)">
						<app-icon name="chevron-left" size="smallest" color="primary-1" hoverColor="secondary-1"></app-icon>
					</div>
				}
				@if (showPrevious()) {
					<div class="button" title="Volgende {{ type() }}" (click)="changeElement.emit(true)">
						<app-icon name="chevron-right" size="smallest" color="primary-1" hoverColor="secondary-1"></app-icon>
					</div>
				} @else {
					<div class="placeholder"></div>
				}
			</div>
		</div>
		<div class="bottom-list">
			@for (detail of detailsElementData.details; track detail.label) {
				<p class="title">{{ detail.label }}</p>
				<p [class.default]="detail.waarde == '-'">{{ detail.waarde }}</p>
			}
		</div>
	</div>
}
